<script>
	import Card from '$lib/Components/Card/Card.svelte';
	import Person from './Person.svelte';
	import Rating from './Rating.svelte';
	let { name, body, date, timeAgo, rating = 5 } = $props();

	let id = Math.random().toString(36).slice(2);
</script>

{#snippet headerIndowBlue()}
	<div class="bg-indow-blue flex flex-row gap-2 px-3 pt-3 pb-2">
		<div
			itemprop="author"
			itemscope
			itemtype="https://schema.org/Person"
			class="flex flex-row gap-2"
		>
			<Person class="text-indow-white w-5.5" />

			<h3
				class="text-indow-white mb-0 min-h-[1.1rem]
			flex-grow overflow-x-hidden p-0 text-left text-base leading-none font-normal text-ellipsis whitespace-nowrap normal-case
			"
				itemprop="name"
			>
				{name}
			</h3>
		</div>

		<Rating stars="5" {rating} class="flex-shrink justify-end" />
	</div>
{/snippet}

<Card class="">
	{#snippet header()}
		{@render headerIndowBlue()}
	{/snippet}

	<div class="comment min-h-28 text-sm" itemprop="reviewBody">
		{#if body.length > 170}
			<input type="checkbox" id={`check${id}`} />
			<div class="comment-wrapper">
				<div class="comment-wrapper-inside">
					{#each body.split(/\r?\n/) as paragraph, index (index)}
						<p>{paragraph}</p>
					{/each}
				</div>
				<label
					class=" text-indow-blue !inline cursor-pointer pt-1"
					for={`check${id}`}
				>
				</label>
			</div>
		{:else}
			{#each body.split(/\r?\n/) as paragraph, index (index)}
				<p>{paragraph}</p>
			{/each}
		{/if}
	</div>

	{#snippet footer()}
		<p class="text-indow-grey pr-4 pb-3 text-right text-xs">
			<time datetime={date}>{timeAgo}</time>
		</p>
	{/snippet}
</Card>

<style>
	/*
	Handles the read more smooth collapse
	*/
	.comment p {
		text-align: left !important;
		padding: 0;
		margin: 0;
		line-height: 1.3rem;
	}

	.comment-wrapper {
		display: grid;
		grid-template-rows: 0fr;
		transition: grid-template-rows 300ms ease-in;
	}

	.comment-wrapper-inside {
		min-height: 5.1rem;
		overflow: hidden;
	}

	input {
		display: none;
	}

	input:checked + .comment-wrapper {
		grid-template-rows: 1fr;
	}

	input:checked ~ .comment-wrapper label::after {
		content: ' ... show less.';
	}

	input:not(:checked) ~ .comment-wrapper label::after {
		content: '... show more.';
		font-style: italic;
	}
</style>
